// extracted by mini-css-extract-plugin
export var $animation_name = "Timeline-module--$animation_name--3e280";
export var content = "Timeline-module--content--c9055";
export var entry = "Timeline-module--entry--2c0af";
export var hasSecondary = "Timeline-module--hasSecondary--09171";
export var icon = "Timeline-module--icon--e6d73";
export var image = "Timeline-module--image--2457d";
export var intro = "Timeline-module--intro--42498";
export var logo = "Timeline-module--logo--27b78";
export var paddingWrapper = "Timeline-module--paddingWrapper--05d9b";
export var primary = "Timeline-module--primary--8a957";
export var secondary = "Timeline-module--secondary--d9df0";
export var tag = "Timeline-module--tag--93491";
export var text = "Timeline-module--text--9254b";
export var timelineEntries = "Timeline-module--timelineEntries--47294";
export var wrapper = "Timeline-module--wrapper--e7786";
export var year = "Timeline-module--year--f770a";